import { apiClient } from './client'

export interface SkillGenerateResponse {
  projectName: string
  skillMarkdown: string
}

export interface AgentsGenerateResponse {
  projectName: string
  agentsBlock: string
}

export async function generateSkill(
  projectName: string,
  task?: string
): Promise<SkillGenerateResponse> {
  return apiClient.post<SkillGenerateResponse>('/skill/generate', {
    projectName,
    task,
  })
}

export async function generateAgentsBlock(
  projectName: string,
  repoPath?: string
): Promise<AgentsGenerateResponse> {
  return apiClient.post<AgentsGenerateResponse>('/agents/generate', {
    projectName,
    repoPath,
  })
}

export interface ClaudeHooksGenerateResponse {
  projectName: string
  settingsFragment: unknown
  scriptPath: string
  scriptContent: string
}

export async function generateClaudeHooksSetup(
  projectName: string
): Promise<ClaudeHooksGenerateResponse> {
  return apiClient.post<ClaudeHooksGenerateResponse>('/hooks/claude-code/generate', {
    projectName,
  })
}

export type McpAuthMethod = 'api_key' | 'oauth'

export interface HarnessMcpConfigResponse {
  harness: string
  configPath: string
  configText: string
  restart: string
  remoteMcpUrl: string | null
  apiKeyPlaceholder: string
  configured: boolean
  authMethod: McpAuthMethod
  oauthEnabled: boolean
}

export async function getHarnessMcpConfig(
  harness: string,
  authMethod: McpAuthMethod = 'api_key'
): Promise<HarnessMcpConfigResponse> {
  return apiClient.get<HarnessMcpConfigResponse>(
    `/mcp/harness-config?harness=${encodeURIComponent(harness)}&authMethod=${encodeURIComponent(authMethod)}`
  )
}
